import { useMutation } from '@tanstack/react-query';
import { updateGatewayRuleActive } from 'config/requests/gatewayRules';

type Props = {
  onError: (err: Error) => void;
  onSuccess: () => void;
};
export function useUpdateActiveRule({ onSuccess, onError }: Props) {
  const { mutate } = useMutation({
    mutationFn: ({ id, isActive }: { id?: string; isActive?: boolean }) =>
      updateGatewayRuleActive(id, isActive),
    onSuccess,
    onError,
  });
  return { updateActiveRule: mutate };
}
